// extracted by mini-css-extract-plugin
module.exports = {"roomDisplay":"room-display_roomDisplay__ymNpM","image":"room-display_image__qR5O4"};